import { NgModule } from '@angular/core';
import { NumberWithCommaDirective } from './number-with-comma.directive';

@NgModule({
    declarations: [NumberWithCommaDirective],
    exports: [NumberWithCommaDirective],
})
export class NumberWithCommaDirectiveModule {}
